<form class="flex flex-col"
      [formGroup]="filterState">
  <div class="flex flex-col p-4">
    <span>{{ "TIME_SINCE" | translate }}</span>
    <mat-chip-set aria-label="Quick date-time selection">
      @for (dateTime of quickDateTimeArr; track dateTime) {
        <mat-chip (click)="onQuickDateTimeClick(dateTime)">{{ dateTime }}</mat-chip>
      }
    </mat-chip-set>
  </div>

  <mat-divider></mat-divider>

  <div class="flex flex-col p-4">
    <span class="mb-1">{{ "START_TIME" | translate }}</span>

    <div class="flex">
      <mat-form-field class="mr-2 max-w-[160px]">
        <input matInput
               [max]="getFromDateMax()"
               placeholder="DD/MM/YYYY"
               appGxInput
               [matDatepicker]="fromDatePicker"
               formControlName="fromDate">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('fromDate')) | translate }}</mat-error>
        }
        <mat-datepicker #fromDatePicker
                        (opened)="preventDefault()"
                        (closed)="setDefault()"/>
        <mat-datepicker-toggle [for]="fromDatePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>

      <mat-form-field class="max-w-[120px]">
        <input matInput
               [matTimepickerMax]="getFromTimeMax()"
               placeholder="hh:mm"
               appGxInput
               [matTimepicker]="fromTimePicker"
               formControlName="fromTime">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('fromTime')) | translate }}</mat-error>
        }
        <mat-timepicker #fromTimePicker
                        (opened)="preventDefault()"
                        (closed)="setDefault()"/>
        <mat-timepicker-toggle [for]="fromTimePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </div>

    <span class="mb-1">{{ "END_TIME" | translate }}</span>

    <div class="flex">
      <mat-form-field class="mr-2 max-w-[160px]">
        <input matInput
               [max]="getToDateMax()"
               [min]="getToDateMin()"
               placeholder="DD/MM/YYYY"
               appGxInput
               [matDatepicker]="toDatePicker"
               formControlName="toDate">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('toDate')) | translate }}</mat-error>
        }
        <mat-datepicker #toDatePicker
                        (opened)="preventDefault()"
                        (closed)="setDefault()"/>
        <mat-datepicker-toggle [for]="toDatePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>

      <mat-form-field class="max-w-[120px]">
        <input matInput
               [matTimepickerMax]="getToTimeMax()"
               [matTimepickerMin]="getToTimeMin()"
               placeholder="hh:mm"
               appGxInput
               [matTimepicker]="toTimePicker"
               formControlName="toTime">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('toTime')) | translate }}</mat-error>
        }
        <mat-timepicker #toTimePicker
                        (opened)="preventDefault()"
                        (closed)="setDefault()"/>
        <mat-timepicker-toggle [for]="toTimePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </div>

    <div class="flex justify-end" *ngrxLet="activeFilterModel$; let storedColumnFilterModel;">
      <button class="ag-button ag-standard-button ag-filter-apply-panel-button"
              (click)="onResetClick()">{{ "RESET" | translate }}
      </button>
      <button class="ag-button ag-standard-button ag-filter-apply-panel-button"
              (click)="updateFilter()"
              [disabled]="filterState.invalid || !isDifference(storedColumnFilterModel)">{{ "APPLY" | translate }}
      </button>
    </div>
  </div>
</form>
